module.exports = __webpack_public_path__ + "img/1-7.c724f31a.png";